import { ReactElement } from 'react';
import { Message } from '@messageformat/react';
import TextComponent from '../TextComponent';
import styles from './TextRowComponent.module.scss';

interface TextProps {
  number: string;
  titleId: string;
  msgId: string;
}

const TextRowComponent = ({ number, titleId, msgId }: TextProps): ReactElement => {
  return (
    <div className={styles['text-row-container']}>
      <div className={styles['column-number']} aria-hidden="true">
        {number}
      </div>
      <div className={styles['text-columns']}>
        <h3 className="opds-styles-v1-text-title-xl">
          <span className="sr-only">{number}</span>
          <Message id={titleId} />
        </h3>
        <TextComponent messageId={msgId} twoColumns />
      </div>
    </div>
  );
};

export default TextRowComponent;
